<template>
    <li
        class="p-lg w-full border-l-lg border-neutral-light flex justify-between"
        :class="{'border-b-xs': ! isLastAddress}"
    >
        <div>
            <checkbox-input
                v-model="selectedAddress"
                class="mr-md"
                @toggle="selectAddress"
            >
                {{ streetAddress }}
            </checkbox-input>
        </div>
        <span v-if="isAssigned">
            <small>(Tilldelad)</small>
        </span>
    </li>
</template>

<script>
    export default {
        props: {
            address: {
                required: true,
                type: Object,
            },
            isLastAddress: {
                required: true,
                type: Boolean,
            },
            selectedAddresses: {
                required: true,
                type: Array,
            },
            assignedAddresses: {
                required: true,
                type: Array,
            },
        },

        data() {
            return {
                selectedAddress: false,
            };
        },

        computed: {
            isAssigned() {
                return this.address.pivot.user_id;
            },

            streetAddress() {
                const address = this.address;

                if (address.street_number) {
                    return `${address.street_name} ${address.street_number}`;
                }

                return address.street_name;
            },
        },

        watch: {
            selectedAddresses() {
                this.selectIfInSelectedAddresses();
            },
        },

        created() {
            this.selectIfInSelectedAddresses();
        },

        methods: {
            selectAddress() {
                EventBus.$emit('select-address', this.address);
            },

            selectIfInSelectedAddresses() {
                const index = this.selectedAddresses
                    .findIndex(
                        address => address.id === this.address.id,
                    );

                const shouldBeChecked = index > -1;
                this.selectedAddress = shouldBeChecked;
            },
        },
    };
</script>
